import React, { useContext, useMemo, useReducer } from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { DialogContext } from '../dialog-context';
const dialogProviderReducer = (state, action) => {
  var _action$payload;
  switch (action.type) {
    case 'open':
      return {
        ...state,
        DialogComponent: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.DialogComponent) || null,
        isOpen: true
      };
    case 'close':
      return {
        ...state,
        DialogComponent: null,
        dialogProps: null,
        isOpen: false
      };
    default:
      throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
  }
};
const DialogWithModalTransition = props => {
  const {
    DialogComponent,
    isOpen,
    onClose
  } = props;
  const {
    closeDialog
  } = useContext(DialogContext);
  if (!DialogComponent) {
    return null;
  }
  const handleCloseDialog = () => {
    closeDialog();
    if (onClose) {
      onClose();
    }
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.cloneElement(DialogComponent, {
    onClose: handleCloseDialog
  }));
};
const DialogProvider = ({
  children
}) => {
  const [dialogProviderState, dispatch] = useReducer(dialogProviderReducer, {
    DialogComponent: null,
    isOpen: false
  });
  const value = useMemo(() => ({
    openDialog: DialogComponent => dispatch({
      type: 'open',
      payload: {
        DialogComponent
      }
    }),
    closeDialog: () => dispatch({
      type: 'close'
    })
  }), []);
  return /*#__PURE__*/React.createElement(DialogContext.Provider, {
    value: value
  }, children, /*#__PURE__*/React.createElement(DialogWithModalTransition, dialogProviderState));
};
export { DialogWithModalTransition, DialogProvider };